export enum Environment {
  DEV = 'dev',
  PROD = 'prod',
  STAGE = 'stage',
  MASTER = 'master',
  LOCAL = 'local',
}

export enum Region {
  EU = 'eu',
  US = 'us',
}
